module.exports = __webpack_public_path__ + "img/22_8.ebe1f1c9.png";